<template>
    <div>
        <el-tabs type="card" v-model="activeName" class="cust-tabs" @tab-click="handleClick">
            <el-tab-pane :label="$t('Dashboard')" v-if="$store.state.config.user.role_slug.indexOf('club') >= 0" name="dashboard">
                <dashboard v-if="dashboardShow"></dashboard>
            </el-tab-pane>
            <el-tab-pane :label="$t('Details')" v-if="$store.getters.getConfig('has_permissions').includes('clubs-show')" name="detail">
                <club-details v-if="detailShow" :club_slug="$route.params.club_slug || club_slug" />
            </el-tab-pane>
            <el-tab-pane :label="$t('Cases')" v-if="$store.getters.getConfig('has_permissions').includes('patenkinders-cases-index')" name="case">
                <cases v-if="caseShow" :club_slug="$route.params.club_slug || club_slug" />
            </el-tab-pane>
            <el-tab-pane :label="$t('Archive')" v-if="$store.getters.getConfig('has_permissions').includes('patenkinders-cases-index')"  name="pastcase">
                <past-cases v-if="pastCasesShow" :club_slug="$route.params.club_slug || club_slug" />
            </el-tab-pane>
            <el-tab-pane :label="$t('Contacts')" v-if="$store.getters.getConfig('has_permissions').includes('club-users-getClubUsers')" name="contact">
                <club-contacts v-if="contactShow" :club_slug="$route.params.club_slug || club_slug" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Dashboard from './DashboardTab'
    import ClubContacts from './Contacts'
    import ClubDetails from './ClubDetails'
    import Cases from '../Cases/Cases'
    import PastCases from '../Cases/PastCases'

    export default {
        components: {
            Dashboard,
            ClubContacts,
            ClubDetails,
            Cases,
            PastCases
        },
        props: {
            club_slug: String
        },
        data() {
            return {
                activeName: (this.$route.query.at) ? this.$route.query.at : (this.$store.state.config.user.role_slug.indexOf('club') >= 0 ? 'dashboard' : 'detail' ),
                dashboardShow: true,
                detailShow: false,
                caseShow: false,
                pastCasesShow: false,
                contactShow: false
            };
        },
        mounted() {
            this.activeTab(this.activeName);
        },
        methods: {
            handleClick(tab, event) {
                this.activeTab(tab.name);
            },
            activeTab(tab) {
                var self = this;

                self.dashboardShow = true,
                self.detailShow = false,
                self.caseShow = false,
                self.pastCasesShow = false,
                self.contactShow = false
                if(tab == "dashboard") {
                    if (this.$route.query.at)
                        this.$router.replace('/dashboard');

                    Vue.nextTick(function (){
                        self.dashboardShow = true;
                    });
                } else if(tab == "detail") {
     
                    Vue.nextTick(function (){
                        self.detailShow = true;
                    });
                } else if(tab == "case") {
     
                    Vue.nextTick(function (){
                        self.caseShow = true;
                    });
                } else if(tab == "pastcase") {
     
                    Vue.nextTick(function (){
                        self.pastCasesShow = true;
                    });
                } else if(tab == "contact") {
     
                    Vue.nextTick(function (){
                        self.contactShow = true;
                    });
                }
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/Clubs/Dashboard.vue